import HandleTabel from './containers/handle_tabel/TablePage';
import TestPage from './containers/handle_tabel/TestPage';
import './index.less';
import React, { useState } from 'react';
// import { useDispatch } from 'dva';
import { history } from 'umi';
import ButtonML from '@/components/button_ml/ButtonML';

const UnitTest = (props) => {
  const [val, setVal] = useState(null);
  const { id, name } = props.location.query;

  // const dispatch = useDispatch();
  // 发起请求
  // const fetchData = useCallback(() => {
  //   dispatch({
  //     type: 'conditionDetail/getHandleList',
  //     payload: {
  //       values: {
  //         hostId: id,
  //         hostType: 'RULE_OUTPUT_RESULT',
  //       },
  //     },
  //   });
  // }, [dispatch, id]);
  // useEffect(() => {
  //   fetchData();
  // }, [fetchData]);
  const handleClick = (s) => {
    setVal(s);
  };
  return (
    <div className="re">
      <div className="contain">
        <ButtonML
          size="large"
          value="返回"
          // width="106px"
          // height="46px"
          fontsize="16px"
          onClick={() => history.go(-1)}
        />
        <HandleTabel name={name} id={id} handleClick={handleClick} />
        <p className="dri_space"></p>
        <TestPage name={name} id={id} val={val} />
      </div>
    </div>
  );
};

export default UnitTest;
